<template>
  <vue-final-modal v-model="medleyModalVisible" name="medley-dialog"
    :classes="['medley-dialog__container']"
    :styles="{ display: 'flex', alignItems: 'center', justifyContent: 'center' }"
    :content-class="['medley-dialog__content', 'v--modal-box', 'v--modal']"
    :click-to-close="true" :lock-scroll="true"
    @opened="onMedleyModalOpened" @closed="onMedleyModalClosed"
    @before-close="handleBeforeClose">
    <div style="text-align: left;">
      <p style="color: gray; border: 1px solid; display: inline;">PR</p>
    </div>
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeMedleyDialog" icon="el-icon-circle-close" style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="setting">
      <div style="text-align: center;">
        <div style="display: inline-block; min-width: 100%; text-align: center; padding: 10px;">
          <img :src="dialogInfo.logoImage" style="max-width: 100%;">
        </div>
        <p style="margin-bottom: 10px;">ダウンロードが完了しました！</p>
        <p style="margin-bottom: 10px;">選考と合わせて、好条件の医療介護系求人が掲載されているジョブメドレーへの登録もしてみてね！</p>
        <div style="display: inline-block; min-width: 100%; text-align: center; margin-bottom: 20px;">
          <div
            style="text-align: left; margin-left: 0.5rem; font-size: 120%; font-weight: bold; line-height: 1.3; margin-bottom: 20px;">
            <div style="padding-bottom: 10px; display: flex; align-items: center;">
              <p
                style="display: block; background:#0F9934; width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
              </p>
              <p style="font-size: 120%; font-weight: bold;">医療系求人数業界No.1</p>
            </div>
            <div style="padding-bottom: 10px; display: flex; align-items: center;">
              <p
                style="display: block; background:#0F9934; width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
              </p>
              <p style="font-size: 120%; font-weight: bold;"><span
                  style="font-size: 80%;">自分のペースで職探しが可能</span><br>しつこい電話や催促もなし！</p>
            </div>
            <div style="display: flex; align-items: center;">
              <p
                style="display: block; background:#0F9934; width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
              </p>
              <p style="font-size: 120%; font-weight: bold;"><span
                  style="font-size: 80%;">事業所から直接スカウトが届くかも？</span><br>今すぐ60秒で簡単無料登録！</p>
            </div>
          </div>
        </div>
        <p v-if="dialogInfo.termurl" style="font-size: 80%; margin-bottom: 10px;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          {{ dialogInfo.clientName }}の<a :href="dialogInfo.termurl" target="_blank">利用規約</a>、<a
            :href="dialogInfo.privacyurl" target="_blank">個人情報保護方針</a>を
          <br>確認して{{ dialogInfo.clientServiceName }}に登録することになります。
        </p>
        <div>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="!isSendedMedley"
            style="background-color: #E3165C; border-color: #E3165C; font-size: 120%; width: 100%;"
            @click="sendMedleyConsult()">登録をする</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-else
            style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeMedleyDialog()">送信しました</el-button>
        </div>
      </div>
    </div>
  </vue-final-modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script setup lang="ts">
import { ref, computed, inject, onBeforeMount, onUnmounted, nextTick, getCurrentInstance } from 'vue'
import { emitRtDialogClosedWithoutSubmit } from '@/plugins/emitter'
import { useRealtimeTransferSend, RtSendFactoryKey } from '@/composables/useRealtimeTransferSend'

const vm = getCurrentInstance()!.proxy as any

const isMypage = ref(false)
const formatid = ref('')
const previewHtml = ref('')
const permissionType = ref(4)
const isSendedMedley = ref(false)
const fullscreenLoading = ref(false)
const clientId = ref('medley_link')
const dialogName = ref('medley_dialog')
const username = ref('')
const isAgree = ref(true)
const basicData = ref<Record<string, any>>({})
const dialogInfo = ref<Record<string, any>>({})
const medleyModalVisible = ref(false)
const medleyModalOpened = ref(false)
const pendingReshow = ref(false)
const replacingOpen = ref(false)

const pdfFormData = computed(() => {
  const fd = new FormData()
  fd.append('app_html', previewHtml.value)
  fd.append('pdf_option', 'A4')
  return fd
})

function createFilename (ext: string): string {
  const now = new Date()
  const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX ?? ''
  const dateString = vm.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
  return `${prefix}${formatid.value}${dateString}.${ext}`
}

function getPrefName (): string { return '' }
function getCityName (): string { return '' }

function openMedleyDialog (id: string, html: any, perm: number, info: Record<string, any>, bd: Record<string, any>, mypage = false) {
  isMypage.value = mypage
  formatid.value = id
  previewHtml.value = html && html.$el ? html.$el.innerHTML : ''
  permissionType.value = perm === 0 ? 4 : perm
  dialogInfo.value = info
  basicData.value = bd || {}
  clientId.value = info.clientId ?? 'medley_link'
  dialogName.value = info.dialogName ?? 'medley_dialog'
  isSendedMedley.value = false

  const formData = new FormData()
  formData.append('uuid', vm.$firebase.user.uid)
  formData.append('format_id', formatid.value)
  formData.append('dialog_name', dialogName.value)
  formData.append('permission_type', String(permissionType.value))
  formData.append('device_flg', vm.$deviceLib.isMobileDevice ? 'SP' : 'PC')
  formData.append('version', '2')
  formData.append('is_mypage', isMypage.value ? 'true' : 'false')
  formData.append('site_flag', 'r')
  formData.append('app_flag', vm.$site.appFlag)
  vm.$axios.post(vm.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })

  vm.$iterateStorage((value: any, key: string) => {
    if (key === 'basicData') username.value = `${value.lastName}_${value.firstName}`
  }, (err: any) => { if (!err) console.log('Iteration has completed') })

  if (medleyModalOpened.value) {
    pendingReshow.value = true
    replacingOpen.value = true
    medleyModalVisible.value = false
  } else {
    nextTick(() => { medleyModalVisible.value = true })
  }
}

function onMedleyModalOpened () { medleyModalOpened.value = true }

function onMedleyModalClosed () {
  medleyModalOpened.value = false
  if (pendingReshow.value) {
    pendingReshow.value = false
    replacingOpen.value = false
    nextTick(() => { medleyModalVisible.value = true })
  }
}

function closeMedleyDialog () { medleyModalVisible.value = false }

function handleBeforeClose () {
  if (replacingOpen.value) return
  if (!isSendedMedley.value) {
    vm.$eventHub.$emit('update_rt_condition', clientId.value, permissionType.value)
    emitRtDialogClosedWithoutSubmit()
  }
}

const rtSendFactory = inject(RtSendFactoryKey, useRealtimeTransferSend)
const { sendMedleyConsult } = rtSendFactory({
  vm,
  isAgree,
  isRealtimeTransferCommonSended: isSendedMedley,
  fullscreenLoading,
  pdfFormData,
  formatid,
  username,
  clientId,
  dialogName,
  permissionType,
  basicData,
  dialogInfo,
  isMypage,
  createFilename,
  getPrefName,
  getCityName
})

vm.$iterateStorage((value: any, key: string) => {
  if (key === 'basicData') username.value = `${value.lastName}_${value.firstName}`
}, (err: any) => { if (!err) console.log('Iteration has completed') })

let mittGVPopupHandler: ((argList: unknown) => void) | undefined

onBeforeMount(() => {
  mittGVPopupHandler = (argList: unknown) => {
    if (Array.isArray(argList)) openMedleyDialog.apply(null, argList as any)
  }
  vm.$emitter.on('open-medley-dialog', mittGVPopupHandler)
  vm.$emitter.on('send-medley-consult', sendMedleyConsult)
  vm.$eventHub.$on('popstate', closeMedleyDialog)
})

onUnmounted(() => {
  vm.$emitter.off('open-medley-dialog', mittGVPopupHandler)
  vm.$emitter.off('send-medley-consult', sendMedleyConsult)
  vm.$eventHub.$off('popstate', closeMedleyDialog)
})
</script>

<style scoped lang="scss">
/* content-class は VueFinalModal 内部のノードのため scoped だけだと [data-v-*] が付かない → :deep() で子まで適用 */
:deep(.medley-dialog__container) {
  box-sizing: border-box;
  align-items: flex-start !important;
  overflow-y: auto;
  padding: 40px 0;
  -webkit-overflow-scrolling: touch;
}

:deep(.medley-dialog__content) {
  background: #fff;
  box-sizing: border-box;
  flex: 0 1 auto;
  align-self: center;
  width: 600px;
  max-width: 100%;
  height: auto;
  margin-top: auto;
  margin-bottom: auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: visible;
}
</style>
